import { render, staticRenderFns } from "./MeasureMenuCustomCombinationMeasuresList.vue?vue&type=template&id=0663c60a&"
import script from "./MeasureMenuCustomCombinationMeasuresList.vue?vue&type=script&lang=js&"
export * from "./MeasureMenuCustomCombinationMeasuresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports